import React, { Component } from 'react';
import { getStyleValue, convertDMYtoYMD } from '../Helpers/Helpers';
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import moment from 'moment'
import cookie from 'js-cookie';
import "moment/locale/fr";

import "moment/locale/nl";
import "moment/locale/de";
import "moment/locale/nl-be";
import { Button } from '@mui/material';

function getProperDate (datelike) {
	return datelike ? moment(convertDMYtoYMD(datelike)) : false
}

/**
 * SimpleInput renders a simple (hidden) input
 * The DatePicker uses this input to store the date value; the default
 * component it uses is a <TextField /> which would have been fine if not
 * for the fact that DatePicker doesn’t properly pass the `data-notrequired`
 * prop as an attribute to the underlying <input> element. Yet, we need that
 * attribute on an input field, since in Inspection.js all form fields are
 * iterated through to collect postable data. Hence: SimpleInput ¯\_(ツ)_/¯
 */
const SimpleInput = props => {
	return (
		<input
			data-notrequired={props['data-notrequired']}
			type={'hidden'}
			name={props.name}
			value={props.date ? props.date.format('DD-MM-YYYY') : ''}
			disabled={props.readOnly}
			readOnly={props.readOnly} />
	)
}

class DatePickerUI extends Component {
	constructor(props) {
		super(props);

		this.state = {
			date: getProperDate(props.value),
			isOpen: false
		}
	}
	componentDidMount () {
		moment.locale(cookie.get('language'))
	}
	/**
	 * Stores date in state & runs onChange function that saves date in form, for later extraction in Inspection.js
	 * date {Moment}
	 */
	handleChange(date) {
		this.setState({ date })

		if (this.props.onChange && typeof this.props.onChange === 'function') {
			this.props.onChange(this, date);
		}
	}

	onClick() {
		this.setState({ isOpen: true })
	}

	static getDerivedStateFromProps(props, state) {
		if (props.clearable) { // built specifically for Maintenance datepicker <3
			if (props.value !== null) {
				return {
					date: getProperDate(props.value)
				}
			} else if (state.date) {
				return {
					date: null
				}
			}
		}
		return null
	}

	render() {
		const { error, ...filteredProps } = this.props;
		const locale = this.props.locale

		return (
			<div
				id={this.props.name}
				style={{marginTop: getStyleValue('spacing-half')}}
				{...filteredProps}>
				<Button
					className={error ? 'button--error': ''}
					variant="contained"
					onClick={this.onClick.bind(this)}
					disabled={this.props.readOnly}
					color={this.state.date ? "primary" : "secondary"}
				>
					{this.state.date ? this.state.date.format('D MMMM YYYY') : this.props.label}
				</Button>
				<LocalizationProvider
					dateAdapter={ AdapterMoment }
					adapterLocale={ locale }>
					<MobileDatePicker
						renderInput={() => <SimpleInput {...this.props} date={ this.state.date || '' } /> }
						value={ this.state.date ? this.state.date.format('D MMMM YYYY') : '' }
						open={this.state.isOpen}
						onOpen={() => this.setState({ isOpen: true })}
						onClose={() => this.setState({ isOpen: false })}
						onChange={this.handleChange.bind(this)}
						cancelLabel={this.props.t.cancel_datepicker}
						data-notrequired={this.props['data-notrequired']}
						readOnly={this.props.readOnly}
						disabled={this.props.readOnly}
						closeOnSelect={ true }
					/>
				</LocalizationProvider>
			</div>
		);
	}
}

export default DatePickerUI;
